import { render, staticRenderFns } from "./GoogleAnalytics4Link.vue?vue&type=template&id=36f36074&"
import script from "./GoogleAnalytics4Link.vue?vue&type=script&lang=js&"
export * from "./GoogleAnalytics4Link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports